// Copyright 2025 IOTA Stiftung.
// SPDX-License-Identifier: Apache-2.0.

/**
 * Options for the Policy Information Point Component.
 */
export interface IPolicyInformationPointServiceConstructorOptions {
	/**
	 * The logging component for logging policy information.
	 */
	loggingComponentType?: string;
}
